export default {
  "nl": {
    "issue_list": {
      "actions": {
        "add_units": "Voeg units toe",
        "all_units_assigned": "Alle units toegevoegd",
        "check": "Controleren",
        "create_issue_lists": "Maak puntenlijst | Maak puntenlijsten",
        "delete": "Verwijder...",
        "delete_count": "Je staat op het punt om punten voor {count} unit te verwijderen. Ben je zeker? | Je staat op het punt om punten voor {count} units te verwijderen. Ben je zeker?",
        "delete_issue_lists": "Verwijderen punten",
        "edit": "Bewerken",
        "edit_issue_list": "Bewerk puntenlijst",
        "generatePDF": "PDF genereren",
        "go_to_summary": "Ga naar samenvatting",
        "new": "Nieuw punt",
        "new_customer": "Meld een defect",
        "new_issue_list": "Nieuwe puntenlijst",
        "selectAll": "Selecteer alle {totaal} lijsten",
        "unSelectAll": "Wis selectie",
        "update": "Update"
      },
      "attributes": {
        "date": "Startdatum",
        "description": "Beschrijving",
        "name": "Naam"
      },
      "labels": {
        "completed_header": "{completed_count} van {issues_count} punten voltooid",
        "customer": "Klant",
        "date": "Startdatum (optioneel)",
        "delete_explanation": "Alle punten samen met hun afbeeldingen en documenten zullen permament van het platform verwijderd worden.",
        "description_title": "Voeg een beschrijving toe",
        "hide_count": "Verberg punten voor 1 unit | Verberg punten voor {count} units",
        "issue_list": "Puntenlijst",
        "issue_lists": "Puntenlijsten",
        "no_lists_completed": "Geen punten voltooid",
        "partners": "Partners",
        "process_issues": "Verwerk 1 punt | Verwerk {count} punten",
        "project_units_total": "{project_name} heeft {units_count_max} units in totaal",
        "publish_now": "Nu publiceren?",
        "published_count": "Publiceer punten voor 1 unit | Publiceer punten voor {count} units",
        "save_explainer": "Maak de (toekomstige) punten zichtbaar voor klanten? Of opslaan en later publiceren?",
        "selectOne": "Selecteer minimaal 1 lijst",
        "selected": "{selected} lijst geselecteerd. | {selected} lijsten geselecteerd",
        "status": "status",
        "step_1_info": "Bv, voorlopige of finale oplevering, punten in de keuken of badkamer,...",
        "step_1_title": "Welk type puntenlijst wil je maken?",
        "step_2_subtitle": "Selecteer het project om alle units toe te voegen. Je kan later steeds meer units toevoegen.",
        "step_2_title": "Voor welke units wil je punten loggen?",
        "tab_issue_list_documents": "Documenten",
        "tab_issue_list_issues": "Punten",
        "tab_issue_list_issues_customer": "Nazorg",
        "tab_issue_list_tickets": "Gesprekken",
        "tab_issues": "Alle punten",
        "tab_units": "Units",
        "totalSelected": "Alle {total} lijsten zijn geselecteerd",
        "you_have_customer_issues": "U heeft 1 onverwerkt punt | U heeft {aantal} onverwerkte punten van klanten"
      },
      "navigation": {
        "back_to_issue_lists": "Terug naar puntenlijsten"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Log punten voor units in deze lijst.",
            "title": "Maak je eerste puntenlijst"
          }
        },
        "partners": {
          "subtitle": "Je krijgt een melding wanneer er nieuwe punten zijn aangemaakt",
          "title": "Er zijn nog geen punten aan jou toegewezen"
        }
      },
      "validation": {
        "name_already_taken": "Naam is reeds gebruikt in dit project.",
        "need_name": "Naam is verplicht"
      }
    }
  }
}